

export default {

    mixins: [],
    components: {

    },

    computed: {

        account() {
            return this.$store.getters.getAccount;
        },

        accountLogo() {
            return this.$store.getters.getAccountLogo;
        }

    },

    head() {
        return {
            title: 'This shop is currently unavailable - ' + this.account.name
        }
    }

}
